import { createFileRoute } from "@tanstack/react-router";
import PreviewHero3D from "@/pages/PreviewHero3D";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/preview-hero-3d/")({
  head: () => routeHead("/preview-hero-3d/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PreviewHero3D />
  );
}
